import React, { useEffect, useContext } from "react";
import { useParams } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { AppContext, DispatchContext } from "../AppContext";
import * as actions from "../actions/actions";
import Service from "../services/service";
import CircularProgress from '@material-ui/core/CircularProgress';

export default function Checkout(props) {

  const useStyles = makeStyles((theme) => ({
    root: {
      display: "flex",
      flexDirection: "column",
      width: "100%",
      height: "100vh",
      background: theme.palette.background.image,
      backgroundSize: "cover",
      padding: theme.spacing(2),
      justifyContent: "center",
      alignItems: "center",
      color: "white"
    }
  }));

  const dispatch = useContext(DispatchContext);
  const state = useContext(AppContext);
  const classes = useStyles();
  const { id } = useParams();

  useEffect(() => {
    Service.getPaymentStatus(id).then((res) => {
      if (res.success) {
        const status = res.data.status;
        const isBackNav = sessionStorage.getItem('mollieCheckoutBackNav') === '1';
        if (isBackNav) sessionStorage.removeItem('mollieCheckoutBackNav');

        const isGoodStatus = status === "pending" || status === "open" || status === "paid";
        // On browser-back, the payment is still 'open' (user never completed it).
        // Send them back to payment selection (step 4) with an explanatory toast.
        const goToStep = (isBackNav || !isGoodStatus) ? 4 : 5;
        dispatch(actions.setUI({ paymentDialogVisible: true }));
        if (res.data.uploadId && status === "paid") {
          dispatch(actions.setCheckoutDetails({ wizard: { step: 10, uploadId: res.data.uploadId }, invoiceId: id, paymentStatus: status, paid: res.data.paid }));
          dispatch(actions.navigate_to("/wizard"));
        } else {
          // Forward to PaymentDialog — it will handle polling if status is still 'open'/'pending'
          dispatch(actions.setCheckoutDetails({ paymentStep: goToStep, invoiceId: id, paymentStatus: status, paid: res.data.paid }));
          dispatch(actions.navigate_to("/"));
          if (isBackNav) {
            dispatch(actions.openToast({ type: "info", message: state.strings.paymentDialog.paymentCanceled }));
          } else if (!isGoodStatus) {
            dispatch(actions.openToast({ type: "error", message: state.strings.paymentDialog.paymentFailed }));
          }
        }
      } else {
        dispatch(actions.navigate_to("/"));
        dispatch(actions.openToast({ type: "error", message: res.errors[0], status: true }));
      }
    });
  }, []);


  return (
    <div className={classes.root}>
      <CircularProgress color="inherit" />
    </div>);
}
